<template>
    <div class="modal" :class="{ 'is-active': isActive }">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-content">
            <div class="box">
                <article class="media">
                    <div class="media-content">
                        <div class="content">
                            <h3 class="title has-text-danger has-text-centered">DELETE THIS MULTIPROFORMA?</h3>
                            <div class="has-text-centered">
                                <a class="button" @click="closeModal">close</a>
                                <a class="button is-danger" @click="deleteThisProforma">DELETE</a>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </div>
        <button class="modal-close is-large" aria-label="close" @click="closeModal"></button>
    </div>
</template>

<script>
    export default {
        props: ['invoiceId'],
        computed: {
            isActive() {
                return this.$store.getters.getMultiProformaDeleteModalStatus
            }
        },
        methods: {
            closeModal () {
                this.$store.dispatch('setMultiProformaDeleteModalStatus', false)
            },
            deleteThisProforma () {
                this.$store.dispatch('deleteMultiInvoiceById', this.invoiceId)
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Users/User/Tabs/MultiProformaModal/DeleeteMultiProformaModal.vue